(function () {
  'use strict';

  angular.module('app').component('masterAccountMaintenance', masterAccountMaintenance());

  function masterAccountMaintenance() {
    return {
      bindings: {},
      controller: MasterAccountMaintenanceComponent,
      controllerAs: 'vm',
      templateUrl:
        './app/ajs/admin/system-maintenance/components/master-account-maintenance/master-account-maintenance.component.html',
    };
  }

  MasterAccountMaintenanceComponent.$inject = ['UtilService', 'SystemMaintenanceService'];

  function MasterAccountMaintenanceComponent(UtilService, SystemMaintenanceService) {
    var vm = this;

    vm.permissions = {
      canUpdateMasterAccountDatabase: true,
    };

    vm.UtilService = new UtilService(vm);

    // Methods
    vm.updateMasterAccountDatabase = updateMasterAccountDatabase;

    function updateMasterAccountDatabase() {
      if (!vm.permissions.canUpdateMasterAccountDatabase) {
        return;
      }

      SystemMaintenanceService.updateMasterAccountDatabase({});
    }
  }
})();
